import productService from './ProductService'

export default productService
